import { render, staticRenderFns } from "./communityCourseEdit.vue?vue&type=template&id=6cdd83ea&"
import script from "./communityCourseEdit.vue?vue&type=script&lang=js&"
export * from "./communityCourseEdit.vue?vue&type=script&lang=js&"
import style0 from "./communityCourseEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports